module.exports = __webpack_public_path__ + "static/assets/4cde6a5a04b3da9029f8ce9f30a2691d.png";